<template>
  <div>
    <b-modal
      class="modal-add-participants"
      id="modal-add-participants"
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      centered
      size="l"
      :title="text"
    >
      <div>
        <label>Participants: </label>
        <b-form-group>
          <custom-select
            v-model="selectedEmployees"
            :options="optionEmployees"
            multiple
            placeholder="Select employee"
            value-field="employeeId"
            text-field="fullName"
          />
        </b-form-group>
      </div>
      <div class="mt-3 d-flex justify-content-center">
        <b-button
          class="text-white"
          variant="warning"
          type="submit"
          block
          @click="addParticipants"
        >
          {{ variantForm }}
          <b-spinner
            v-if="isBusy"
            class="ml-1"
            label="Spinning"
            small
          />
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import api from '@/api'

export default {
  props: {
    text: {
      type: String,
      default: ''
    },
    modeUpdate: {
      type: Boolean,
      default: false
    },
    dataUpdate: {
      type: Object,
      default: () => {}
    },
    employee: {
      type: Array,
      default: () => []
    },
    listParticipant: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      form: {
        eventId: '',
        employeeId: []
      },
      optionEmployees: [],
      selectedEmployees: [],
      isBusy: false,
      messageRequest: {
        text: '',
        variantAlert: ''
      }
    }
  },
  computed: {
    variantForm() {
      return this.modeUpdate ? 'Update' : 'Create'
    }
  },
  methods: {
    async addParticipants() {
      try {
        this.isBusy = true
        this.convertNameToId()
        const existingParticipants = this.listParticipant.filter(participant => participant.eventId === this.dataUpdate.id)
        const promises = []
        let hasDuplicateParticipants = false
        for (const employeeId of this.form.employeeId) {
          const isExistingParticipant = existingParticipants.some(participant => participant.employeeId === employeeId)
          if (!isExistingParticipant) {
            const payload = {
              eventId: this.dataUpdate.id,
              employeeId: employeeId
            }
            promises.push(api.eventTraining.createParticipants(payload))
          } else {
            hasDuplicateParticipants = true
          }
        }
        if (hasDuplicateParticipants) {
          this.$bvToast.toast('Some participants are already added to the event', {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        } else {
          await Promise.all(promises)
          this.$bvModal.hide('modal-add-participants')
          this.form = {
            eventId: '',
            employeeId: []
          }
          setTimeout(() => {
            this.$emit('refresh')
          }, 2000)
          this.sendResultToParent('Add Participants success', 'success')
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.isBusy = false
      }
    },
    sendResultToParent(message, variant) {
      this.messageRequest.text = message
      this.messageRequest.variantAlert = variant
      this.$emit('result-request', this.messageRequest)
    },
    convertNameToId() {
      this.form.employeeId = []
      this.selectedEmployees.forEach(item => {
        const matchingEmployee = this.employee.find(employee => employee.fullName === item)
        if (matchingEmployee) {
          this.form.employeeId.push(matchingEmployee.id)
        }
      })
    },
    async updateParticipants() {
      await api.eventTraining.updateEvent(this.dataUpdate.eventId, {
        title: this.dataUpdate.title,
        description: this.dataUpdate.description,
        startDate: this.dataUpdate.startDate,
        endDdate: this.dataUpdate.endDdate,
        dayLength: this.dataUpdate.dayLength,
        method: this.dataUpdate.method,
        participants: this.form.employeeId.lenght,
        budget: this.dataUpdate.budget,
        report: this.dataUpdate.report,
        statusBudget: this.dataUpdate.statusBudget
      })
    }
  },
  watch: {
    dataUpdate: {
      handler(oldValue) {
        this.form = { ...oldValue }
      },
      deep: true
    },
    employee: {
      handler() {
        const options = this.employee.filter((item, index, self) =>
          self.findIndex(obj => obj.fullName === item.fullName) === index
        )
        this.optionEmployees = options.map(item => item.fullName)
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
*{
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif
}

.date-picker{
  width: 35vh;
}

.time-picker{
  margin-left: 10px;
}

.status-budget{
  width: 33vh;
}
</style>
